var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-info" },
    [
      +_vm.$route.query.ywtLayoutStyle === 1
        ? _c("templagte", [_c("role-tab", { attrs: { ywtTab: true } })], 1)
        : _vm._e(),
      _c("div", { staticClass: "iframe_box" }, [
        _c("iframe", {
          ref: "ywtIframeRef",
          style: {
            width: "100%",
            height: +_vm.$route.query.ywtLayoutStyle === 1 ? "76vh" : "86vh"
          },
          attrs: { src: _vm.iframeSrc, frameborder: "0" }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04903788", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04903788","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/ywtSystem.vue
// module id = uL6i
// module chunks = 156